import { useTranslation } from "react-i18next";
import { DateTimer } from "../Timer/dateTimer";

export default function DateTime() {
    const {t, i18n} = useTranslation();

    return (
        <div className="col-6 md:col-4 flex align-items-center">
            <div className="grid w-full xl:text-2xl lg:text-xl md:text-xl">
                <div className='col-12 pb-0 flex md:justify-content-end justify-content-center'>
                    <span className="block text-white font-medium">{t('Date')} : <DateTimer type={1}/></span>
                </div>
                <div className="col-12 py-0 flex md:justify-content-end justify-content-center">
                    <span className="block text-white font-medium">{t('Time')} : <DateTimer type={3}/></span>
                    
                </div>
            </div>
        </div>
    )
}